/**
 * @ComponentFor TrackingImpressionBlock
 */
// This block will never be used, it's just for grouping properties on other blocks.
export default () => {};
